export interface ErrorHandler {
   showError: (error: Error) => Promise<any>;
}

let globalErrorHandler: ErrorHandler = {
   showError: (error: Error): Promise<any> => {
      return Promise.resolve();
   }
}

export const initializeErrorHandler = (errorHandler: ErrorHandler) => {
   globalErrorHandler = errorHandler;
};

export const showError = (error: Error): Promise<any> => {
   return globalErrorHandler.showError(error);
}
